
<template>
  <zj-layout-container>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="16rem"
      :disabled="editable"
    >
      <el-row>
        <el-form-item
          label="上报单位"
          style="display: inline-block"
          prop="ReportCompanyId"
        >
          <el-cascader
            :options="OrgOptions"
            :props="OrgoptionsProps"
            :show-all-levels="false"
            @change="handleChange"
            v-model="ReportCompanyId"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="上报人员"
          prop="ReportName"
          style="display: inline-block"
        >
          <el-input v-model="ruleForm.ReportName"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="上报时间"
          prop="ReportTime"
          style="display: inline-block"
        >
          <el-date-picker
            placeholder="选择日期"
            type="datetime"
            v-model="ruleForm.ReportTime"
          ></el-date-picker>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="上报内容"
          prop="ReportContent"
          style="display: inline-block"
        >
          <el-input type="textarea" v-model="ruleForm.ReportContent"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="上报单位指示"
          prop="SuperiorGuidance"
          style="display: inline-block"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.SuperiorGuidance"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="上报方式"
          prop="ReportWay"
          style="display: inline-block"
        ></el-form-item>
        <el-checkbox-group
          @change="handleCheckedChange"
          v-model="ReportWay"
          style="display: inline-block; position: absolute; line-height: 4rem"
        >
          <el-checkbox
            v-for="item in ReportWayOptions"
            :key="item.ItemKey"
            :label="item.ItemKey"
            :value="item.ItemKey"
            >{{ item.Extend1 }}</el-checkbox
          >
        </el-checkbox-group>
      </el-row>
    </el-form>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
import ZJApis from "../../../../../../api";
import permissionsApi from "../../../../../../request/permissionsApi";
import utils from "../../../../../../utils";
export default {
  name: "ZjReportEventTable",
  controller: "UI",
  action: "ReportEventTable",
  props: {
    reportObj: Object,
    editable: { type: Boolean, default: false },
  },
  data() {
    return {
      ReportWayOptions: [],
      ReportWay: [],
      OrgOptions: [],
      OrgoptionsProps: {
        value: "OrgId",
        label: "OrgName",
        children: "OrgInfos",
        checkStrictly: true,
        emitPath: false,
      },
      valid: "fail",
      ReportCompanyId: [""],
      ruleForm: {
        OrgId: "",
        EventId: "",
        ReportId: "",
        ReportName: "",
        ReportCompanyId: "",
        ReportCompanyName: "",
        ReportContent: "",
        SuperiorGuidance: "",
        ReportTime: new Date(),
        ReportWay: "",
        Validity: 1,
      },
      rules: {
        ReportCompanyId: [{ required: true, message: "请选择上报单位" }],
        ReportName: [{ required: true, message: "请输入上报人员" }],
        ReportContent: [{ required: true, message: "请输入上报内容" }],
      },
    };
  },
  created: function () {
    if (this.CNF("app.isBiaoZhunHua")) {
      permissionsApi
        .findOrganizationTree({ projectCode: this.CNF("app.perProjectCode") })
        .then((res) => {
          if (res.code == 0) {
            let orgArr = utils.flattenArray(res.data);
            const departs = orgArr.map((item) => {
              return {
                Id: item.id,
                OrgId: item.code,
                OrgName: item.name,
                Description: item.description,
                CreateTime: item.createdate,
                Creater: item.creater,
                ModifyTime: item.modifydate,
                Modifier: item.modefier,
                ParentOrgId: item.perOrganizationCode || "",
              };
            });
            let orgs = this.convertToTreeNodes(departs);
            if (orgs) {
              // setIsLeaf() 函数：当无下级组织时，删除 'OrgInfos' 字段。
              const setIsLeaf = function (items) {
                if (items && items.length > 0) {
                  items.forEach((x) => {
                    x.IsLeaf = x && x.OrgInfos && x.OrgInfos.length == 0;
                    if (!x.IsLeaf) {
                      setIsLeaf(x.OrgInfos);
                    } else {
                      delete x["OrgInfos"];
                    }
                  });
                }
              };
              setIsLeaf(orgs);
              this.OrgOptions = orgs;
              if (this.reportObj) {
                var item = this.GetDeptInfo(
                  this.OrgOptions,
                  this.reportObj.ReportCompanyId
                );
                if (item) {
                  // this.ReportCompanyId = item.OrgTiers.split(";");
                  // var reportdept = item.OrgTiers.split(";");
                  // var reportComdep = [];
                  // for (var i = 0; i < reportdept.length; i++) {
                  //   var retitme = this.GetDeptInfo(
                  //     this.OrgOptions,
                  //     reportdept[i]
                  //   );
                  //   if (retitme) {
                  //     reportComdep.push(reportdept[i]);
                  //   }
                  // }
                  this.ReportCompanyId = item.OrgId;
                  // console.log( this.ReportCompanyId);
                }
              }
            }
          } else {
            this.errmsg(res.msg);
          }
        });
    } else {
      new ZJApis.OrgApi()
        .GetOrgTiers({
          OrgId:
            ZJApp.ZJUser.current.Departments.length > 0
              ? ZJApp.ZJUser.current.Departments[0].OrgId
              : "error-no-department",
        })
        .then((r) => {
          var orgs = r.data.Data;
          if (orgs) {
            // setIsLeaf() 函数：当无下级组织时，删除 'OrgInfos' 字段。
            const setIsLeaf = function (items) {
              if (items && items.length > 0) {
                items.forEach((x) => {
                  x.IsLeaf = x && x.OrgInfos && x.OrgInfos.length == 0;
                  if (!x.IsLeaf) {
                    setIsLeaf(x.OrgInfos);
                  } else {
                    delete x["OrgInfos"];
                  }
                });
              }
            };
            setIsLeaf(orgs);
            this.OrgOptions = orgs;
            if (this.reportObj) {
              var item = this.GetDeptInfo(
                this.OrgOptions,
                this.reportObj.ReportCompanyId
              );
              if (item) {
                // this.ReportCompanyId = item.OrgTiers.split(";");
                var reportdept = item.OrgTiers.split(";");
                var reportComdep = [];
                for (var i = 0; i < reportdept.length; i++) {
                  var retitme = this.GetDeptInfo(
                    this.OrgOptions,
                    reportdept[i]
                  );
                  if (retitme) {
                    reportComdep.push(reportdept[i]);
                  }
                }
                this.ReportCompanyId = reportComdep;
                // console.log( this.ReportCompanyId);
              }
            }
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    }

    if (this.reportObj) {
      this.ruleForm = this.reportObj;
      this.ReportWay = this.ruleForm.ReportWay.split(",");
    }
    this.config
      .getUValue("EmergencyService:EmergencyEventReportWay", "")
      .then((reportwayconf) => {
        this.ReportWayOptions = reportwayconf.JValue;
      })
      .catch((e) => {
        console.log(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      });
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    handleCheckedChange(value) {
      this.ReportWay = value;
      this.ruleForm.ReportWay = value.join(",");
    },
    handleChange(value) {
      this.ruleForm.ReportCompanyId = value;
      var item = this.GetDeptInfo(this.OrgOptions, value);
      if (item) {
        this.ruleForm.ReportCompanyName = item.OrgName;
      }
    },
    GetDeptInfo(depts, deptid) {
      if (!depts) return undefined;
      for (var i = 0; i < depts.length; i++) {
        var item = depts[i];
        if (item.OrgId == deptid) {
          return item;
        } else {
          var ret = this.GetDeptInfo(item.OrgInfos, deptid);
          if (ret) {
            return ret;
          }
        }
      }
    },
    GetValidate() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (
            this.ruleForm.ReportCompanyId &&
            this.ruleForm.ReportCompanyId != ""
          ) {
            this.valid = "ok";
          } else {
            this.errmsg("请选择上报部门");
            this.valid = "fail";
          }
        } else {
          this.valid = "fail";
        }
      });
    },
    convertToTreeNodes(dataList) {
      let formatObj = dataList.reduce((pre, cur) => {
        return { ...pre, [cur["OrgId"]]: cur };
      }, {});

      let formatArray = dataList.reduce((arr, cur) => {
        let ParentOrgId = cur.ParentOrgId ? cur.ParentOrgId : 0;
        let parent = formatObj[ParentOrgId];
        if (parent) {
          parent.OrgInfos
            ? parent.OrgInfos.push(cur)
            : (parent.OrgInfos = [cur]);
        } else {
          arr.push(cur);
        }
        return arr;
      }, []);
      return formatArray;
      // this.convertToTreeNodesfunction(formatArray);
    },
  },
};
</script>